<template>
  <section class="f-32">
    <div class="alive_content">
      <img src="@/v2/auto/assets/image/32/slogan.svg" />
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {},
  methods: {},
}
</script>
<style lang="less" scoped>
.f-32 {
  width: 100%;
  position: sticky;
  z-index: 79;
  margin-top: -5px;
  .alive_content {
    width: 100%;
    height: 1900px;
    background: radial-gradient(
      775.21% 100% at 50% 0%,
      #000000 0%,
      #000000 2.61%,
      #04060b 5.81%,
      #131b30 13.7%,
      #1d2744 18.49%,
      #435682 37.3%,
      #9db0de 65.96%,
      #ffffff 100%
    );
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
